import { MainDrawer } from '../../../../shared/components';
import { ChangeDemandState, ListOfStores } from './components';

import { useHighDemandDialog } from './hooks';

export function HighDemandDialog(props: Props) {
  const { open, isSingleStore, onClose } = props;
  const {
    texts,
    goBackBtn,
    primaryBtn,
    stores,
    isLoadingStoreList,
    goToDemandView,
    storeSelected,
    severityTimes,
    processStep,
    onSelectDemandState,
  } = useHighDemandDialog({ onCloseDialog: onClose, isSingleStore });

  return (
    <MainDrawer
      size='medium'
      open={open}
      anchor='right'
      onClose={onClose}
      disableBackdropClick={true}
      onGoBack={goBackBtn.onClick}
      headerTitle={texts.title}
      subtitle={texts.subtitle}
      aria-labelledby='high-demand-dialog'
      primaryBtn={{
        text: texts.primaryBtn,
        onClick: primaryBtn.onClick,
        loading: primaryBtn.isLoading,
      }}
    >
      {processStep.storeList && (
        <ListOfStores
          list={stores}
          onClickStore={goToDemandView}
          isLoading={isLoadingStoreList}
        />
      )}
      {processStep.statusChange && (
        <ChangeDemandState
          store={storeSelected}
          severityTimes={severityTimes}
          onSelect={onSelectDemandState}
        />
      )}
    </MainDrawer>
  );
}

interface Props {
  open: boolean;
  onClose: () => void;
  isSingleStore: boolean;
}
